import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  ConnectedUsersService,
  ConnectionHistoryRecord,
} from '../../services/connected-users.service';
import { ConnectionDetailDialogComponent } from '../connection-history/connection-detail-dialog/connection-detail-dialog.component';

@Component({
  selector: 'app-my-connections',
  templateUrl: './my-connections.component.html',
  styleUrls: ['./my-connections.component.sass'],
})
export class MyConnectionsComponent implements OnInit, OnDestroy {
  records: ConnectionHistoryRecord[] = [];
  pagination = { page: 1, limit: 20, total: 0, totalPages: 0 };

  loading = false;
  errorMessage = '';
  expandedCardId: number | null = null;

  private destroy$ = new Subject<void>();

  pageSizeOptions = [10, 20, 50];
  Math = Math;

  constructor(
    private connectedUsersService: ConnectedUsersService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.loadConnections();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadConnections(): void {
    this.loading = true;
    this.errorMessage = '';

    this.connectedUsersService
      .getMyConnections({ page: this.pagination.page, limit: this.pagination.limit })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.records = response.data || [];
          this.pagination.total = response.meta?.total || 0;
          this.pagination.page = response.meta?.page || 1;
          this.pagination.totalPages = response.meta?.totalPages || 0;
          this.loading = false;
        },
        error: (error) => {
          this.errorMessage = error.message || 'Error al cargar historial de conexiones';
          this.loading = false;
        },
      });
  }

  onPaginatorChange(event: any): void {
    this.pagination.page = event.pageIndex + 1;
    this.pagination.limit = event.pageSize;
    this.loadConnections();
  }

  viewDetail(record: ConnectionHistoryRecord): void {
    const isMobile = window.innerWidth < 768;
    this.dialog.open(ConnectionDetailDialogComponent, {
      data: record,
      maxHeight: '90vh',
      maxWidth: isMobile ? '95vw' : '826px',
      minWidth: isMobile ? '90vw' : '800px',
      width: isMobile ? '95vw' : undefined,
    });
  }

  toggleCard(idx: number): void {
    this.expandedCardId = this.expandedCardId === idx ? null : idx;
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const parts = dateString.split('T')[0].split('-');
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }

  formatTime(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('es-VE', {
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

  getDeviceIcon(deviceType: string): string {
    if (deviceType === 'mobile') return 'phone_android';
    if (deviceType === 'tablet') return 'tablet';
    return 'computer';
  }
}
